module.exports = __webpack_public_path__ + "img/open-and-release.1dcc9179.png";